<template>
  <b-modal
    v-model="modalShow"
    size="xl"
    scrollable
    title="Supplier Return Details"
    @hidden="$emit('modal-closed')"
  >

    <div
      v-if="fetchLoading"
      class="text-center"
    >
      <b-spinner
        label="Small Spinner"
        variant="primary"
      />
    </div>

    <b-alert
      variant="danger"
      :show="fetchError ? true : false"
    >
      <div class="alert-body">
        <p>
          {{ fetchError }}
        </p>
      </div>
    </b-alert>

    <div
      v-if="!fetchLoading && !fetchError"
      style="width: 80%; margin-left: 10%;"
    >
      <b-table-simple
        responsive
      >
        <b-tbody>
          <b-tr>
            <b-th style="width: 18%;">
              Challan Number
            </b-th>
            <b-td style="width: 32%;">
              {{ itemDetails.challan_number }}
            </b-td>
            <b-th style="width: 18%;">
              Challan Date
            </b-th>
            <b-td style="width: 32%;">
              {{ itemDetails.challan_date && formatedDate(itemDetails.challan_date) }}
            </b-td>
          </b-tr>
          <b-tr>

            <b-th>
              Supplier
            </b-th>
            <b-td>
              {{ itemDetails.supplier__identifier }}
            </b-td>
            <b-th>
              Retrun Type
            </b-th>
            <b-td>
              {{ itemDetails.return_type }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th>
              PDF File
            </b-th>
            <b-td>
              <a
                v-if="itemDetails.pdf_file"
                :href="itemDetails.pdf_file"
                target="_blank"
              >
                <span>View File</span>
              </a>
            </b-td>
            <b-th>
              Created By
            </b-th>
            <b-td>
              {{ itemDetails.created_by }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th>
              Total Amount
            </b-th>
            <b-td>
              {{ formateNumber(itemDetails.total_amount) }}
            </b-td>
            <b-th>
              Total Items
            </b-th>
            <b-td>
              {{ itemDetails.total_items }}
            </b-td>
          </b-tr>
          <b-tr />
          <b-tr>
            <b-th>
              Checked By
            </b-th>
            <b-td>
              {{ itemDetails.checked_by__fullname }}
            </b-td>
            <b-th />
            <b-td />
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <b-alert
        variant="danger"
        :show="updateError ? true : false"
      >
        <div class="alert-body">
          <p>
            {{ updateError }}
          </p>
        </div>
      </b-alert>
      <b-table-simple
        class="mt-2"
        bordered
        fixed
      >
        <b-tbody>
          <b-tr>

            <b-th style="width: 18%;">
              Number of Packages
            </b-th>
            <b-td style="width: 32%;">
              <custom-v-select
                v-model="formData.selectedNumberOfPackages"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="numberOfPackagesOptions"
                label="text"
                placeholder="Select Number of Packages"
              />
            </b-td>
            <b-th>
              Docket Number
            </b-th>
            <b-td>
              <b-form-input
                id="docket-number"
                v-model="formData.docketNumber"
                type="text"
                placeholder="Enter Docket Number"
              />
            </b-td>
          </b-tr>
          <b-tr>
            <b-th>
              Dispatch Date
            </b-th>
            <b-td>
              <b-form-datepicker
                id="dispatch_date"
                v-model="formData.dispatchDate"
                menu-class="w-100"
                calendar-width="100%"
              />
            </b-td>
            <b-th>
              Dispatch Courier
            </b-th>
            <b-td>
              <custom-v-select
                id="dispatch-courier"
                v-model="formData.selectedDispatchCourier"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="dispatchCourierOptions"
                label="text"
                placeholder="Select Courier"
              />
            </b-td>
          </b-tr>
          <b-tr>
            <b-th> Checked PDF File </b-th>
            <b-td>
              <b-form-group v-if="!itemDetails.checked_pdf_file">
                <b-form-file
                  v-model="formData.checkedPDF"
                  :disabled="updateLoading"
                  accept=".pdf"
                />

              </b-form-group>
              <a
                v-else
                :href="itemDetails.checked_pdf_file"
                target="_blank"
              >
                <span>View File</span>
              </a>
            </b-td>

            <b-th>
              Remarks
            </b-th>
            <b-td>
              <b-form-textarea
                v-model="formData.remarks"
                rows="2"
              />
            </b-td>
          </b-tr>
          <b-tr>

            <b-th>
              Status
            </b-th>
            <b-td colspan="1">
              <custom-v-select
                v-model="formData.status"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="statusOptions"
                label="text"
                :disabled="updateLoading"
                placeholder="Select Status"
                :clearable="false"
                :reduce="status => status.value"
              />
            </b-td>
            <b-th>
              Adjusted On
            </b-th>
            <b-td>
              <b-form-datepicker
                v-model="formData.closedOn"
                :disabled="updateLoading || status !== 'Adjusted'"
              />
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <b-alert
        variant="warning"
        :show="!!itemDetails.action_required"
        class="mt-1"
      >
        <div class="alert-body">
          <p class="mb-0">
            Action required for this return. Review items and credit notes, then click Action Taken.
            <span v-if="itemDetails.follow_up_date">
              Follow-up date {{ formatedDate(itemDetails.follow_up_date) }}.
            </span>
          </p>
        </div>
      </b-alert>
      <b-alert
        variant="info"
        :show="!!itemDetails.follow_up_date && !itemDetails.action_required"
        class="mt-1"
      >
        <div class="alert-body">
          <p class="mb-0">
            Follow-up on {{ formatedDate(itemDetails.follow_up_date) }}. This challan moves to Action Required on that date.
          </p>
        </div>
      </b-alert>

      <div class="d-flex justify-content-between align-items-center">
        <b-form-checkbox
          switch
          :checked="!!itemDetails.auto_action_required"
          :disabled="autoActionLoading"
          @change="handleAutoActionRequired"
        >
          Auto Action Required
        </b-form-checkbox>
        <div>
          <b-button
            v-if="itemDetails.action_required"
            variant="outline-warning"
            class="mr-1"
            :disabled="actionTakenLoading || updateLoading"
            @click="handleActionTaken"
          >
            Action Taken
            <b-spinner
              v-if="actionTakenLoading"
              label="Small Spinner"
              small
            />
          </b-button>
          <b-button
            variant="primary"
            :disabled="updateLoading || actionTakenLoading"
            @click="handleUpdate"
          >
            Update
            <b-spinner
              v-if="updateLoading"
              label="Small Spinner"
              small
            />
          </b-button>
        </div>
      </div>

      <div
        class="mt-2"
        style="max-width: 42rem;"
      >
        <h5 class="mb-1">
          Activity
        </h5>
        <b-alert
          variant="danger"
          :show="remarkError ? true : false"
        >
          <div class="alert-body">
            <p class="mb-0">
              {{ remarkError }}
            </p>
          </div>
        </b-alert>
        <b-form-textarea
          v-model="newRemark"
          rows="2"
          placeholder="Add a remark..."
          :disabled="remarkLoading"
        />
        <b-form-datepicker
          v-model="followUpDate"
          class="mt-1"
          :min="minFollowUpDate"
          :disabled="remarkLoading"
          placeholder="Follow-up date (optional)"
          reset-button
        />
        <div class="d-flex justify-content-end mt-1 mb-2">
          <b-button
            variant="outline-primary"
            :disabled="remarkLoading || !newRemark.trim()"
            @click="handleAddRemark"
          >
            Add Remark
            <b-spinner
              v-if="remarkLoading"
              label="Small Spinner"
              small
            />
          </b-button>
        </div>
        <app-timeline v-if="timelineEntries.length">
          <app-timeline-item
            v-for="entry in timelineEntries"
            :key="entry.id"
            :variant="timelineVariant(entry.event_type)"
            :icon="timelineIcon(entry.event_type)"
          >
            <div class="d-flex justify-content-between align-items-start mb-0">
              <h6 class="mb-0 mr-1">
                {{ timelineTitle(entry) }}
              </h6>
              <small class="timeline-item-time text-nowrap text-muted flex-shrink-0">
                {{ timelineMeta(entry) }}
              </small>
            </div>
            <p class="mb-0">
              {{ timelineSubtitle(entry) }}
            </p>
            <p
              v-if="entry.follow_up_date"
              class="mb-0 text-muted"
            >
              Follow-up {{ formatedDate(entry.follow_up_date) }}
            </p>
          </app-timeline-item>
        </app-timeline>
        <p
          v-else
          class="text-muted mb-0"
        >
          No activity yet.
        </p>
      </div>
    </div>

    <div
      v-if="!fetchLoading && !fetchError"
      class="mt-2"
    >
      <div class="d-flex justify-content-between align-items-center mb-1">
        <h5 class="mb-0">
          Items
        </h5>
        <b-button
          variant="outline-primary"
          :disabled="rematchLoading || updateLoading"
          @click="handleRematchItems"
        >
          Re-match Items
          <b-spinner
            v-if="rematchLoading"
            label="Small Spinner"
            small
          />
        </b-button>
      </div>
      <b-alert
        variant="danger"
        :show="rematchError ? true : false"
      >
        <div class="alert-body">
          <p>
            {{ rematchError }}
          </p>
        </div>
      </b-alert>
      <supplier-return-item-details
        :items="itemDetails.items"
        :supplier-return-id="itemId"
        @items-updated="handleItemsUpdated"
        @email-sent="fetchDetails"
      />
    </div>

    <hr>

    <b-row>
      <b-col
        align="right"
      >
        <b-button
          variant="outline-primary"
          class="mb-1 ml-2"
          @click="addSupplierCreditNoteHandler"
        >
          Add Supplier Credit Note
        </b-button>

      </b-col>
    </b-row>

    <add-supplier-credit-note
      v-if="showAddForm"
      :supplier-return-id="itemId"
      @cancelled="closeFormsHandler"
      @item-added="closeFormsHandler"
    />
    <edit-supplier-credit-note
      v-else-if="editSupplierCreditNoteId"
      :credit-note-id="editSupplierCreditNoteId"
      @cancelled="closeFormsHandler"
      @item-updated="closeFormsHandler"
    />
    <supplier-credit-note-list
      v-else
      :supplier-return-id="itemId"
      @edit-supplier-credit-note="editSupplierCreditNoteHandler"
    />

    <template #modal-footer>
      <div class="w-100">
        <b-button
          variant="secondary"
          class="float-right"
          @click="modalShow=false"
        >
          Close
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  BButton, BAlert, BSpinner, BTableSimple, BTbody, BTd, BTr, BTh, BRow, BCol, BFormGroup, BFormFile, BFormDatepicker, BFormTextarea, BFormCheckbox,
  BFormInput,
} from 'bootstrap-vue'
import axios from 'axios'
import dateMixin from '@/mixins/dateMixin'
import CustomVSelect from '@/components/UI/CustomVSelect.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import formatMixin from '@/mixins/formatMixin'
import SupplierCreditNoteList from './SupplierCreditNoteList.vue'
import AddSupplierCreditNote from './AddSupplierCreditNote.vue'
import SupplierReturnItemDetails from './SupplierReturnItemDetails.vue'
import EditSupplierCreditNote from './EditSupplierCreditNote.vue'

export default {
  components: {
    BButton,
    BAlert,
    BSpinner,
    BTableSimple,
    BTbody,
    BTd,
    BTr,
    BTh,
    BRow,
    BCol,
    SupplierCreditNoteList,
    AddSupplierCreditNote,
    BFormGroup,
    BFormFile,
    CustomVSelect,
    BFormDatepicker,
    BFormTextarea,
    SupplierReturnItemDetails,
    EditSupplierCreditNote,
    BFormInput,
    BFormCheckbox,
    AppTimeline,
    AppTimelineItem,
  },
  mixins: [dateMixin, formatMixin],
  props: {
    itemId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      itemDetails: {},
      modalShow: true,
      fetchError: null,
      fetchLoading: true,
      showAddForm: false,
      editSupplierCreditNoteId: null,
      statusOptions: [
        { text: 'Open', value: 'Open' },
        { text: 'Partially Adjusted', value: 'Partially Adjusted' },
        { text: 'Adjusted', value: 'Adjusted' },
      ],
      formData: {
        status: null,
        closedOn: '',
        checkedPDF: null,
        selectedDispatchCourier: null,
        selectedNumberOfPackages: null,
        dispatchDate: null,
        remarks: '',
        docketNumber: '',
      },
      updateLoading: false,
      updateError: null,
      rematchLoading: false,
      rematchError: null,
      actionTakenLoading: false,
      autoActionLoading: false,
      newRemark: '',
      followUpDate: '',
      remarkLoading: false,
      remarkError: null,
      dispatchCourierOptions: [],
      numberOfPackagesOptions: [
        { text: '0', value: '0' },
        { text: '1', value: '1' },
        { text: '2', value: '2' },
        { text: '3', value: '3' },
        { text: '4', value: '4' },
        { text: '5', value: '5' },
        { text: '6', value: '6' },
        { text: '7', value: '7' },
        { text: '8', value: '8' },
        { text: '9', value: '9' },
      ],
    }
  },
  computed: {
    status() {
      return this.formData.status
    },
    timelineEntries() {
      return this.itemDetails.timeline_entries || []
    },
    minFollowUpDate() {
      const tomorrow = new Date()
      tomorrow.setDate(tomorrow.getDate() + 1)
      const month = String(tomorrow.getMonth() + 1).padStart(2, '0')
      const day = String(tomorrow.getDate()).padStart(2, '0')
      return `${tomorrow.getFullYear()}-${month}-${day}`
    },
  },
  watch: {
    status(newVal) {
      if (newVal !== 'Adjusted') {
        this.formData.closedOn = ''
      }
    },
  },
  created() {
    this.fetchOptions()
    this.fetchDetails()
  },
  methods: {
    fetchOptions() {
      axios.get('/returns/courier_options')
        .then(res => {
          this.dispatchCourierOptions = res.data.data
        })
    },
    updateFormData() {
      this.formData = {
        ...this.formData,
        status: this.itemDetails.status,
        closedOn: this.itemDetails.closed_on || '',
        selectedDispatchCourier: this.dispatchCourierOptions.find(option => option.id === this.itemDetails.dispatch_courier),
        selectedNumberOfPackages: this.numberOfPackagesOptions.find(option => option.value === this.itemDetails.number_of_packages),
        dispatchDate: this.itemDetails.dispatch_date,
        remarks: this.itemDetails.remarks || '',
        docketNumber: this.itemDetails.docket_number || '',
      }
    },
    fetchDetails() {
      axios.get(`/returns/supplier_return/${this.itemId}`)
        .then(res => {
          this.itemDetails = res.data
          this.fetchError = null
          this.fetchLoading = false

          this.updateFormData()
        })
        .catch(error => {
          this.fetchError = error?.response?.data?.error || 'Something went wrong'
          this.fetchLoading = false
        })
    },
    async handleUpdate() {
      try {
        const {
          status,
          closedOn,
          checkedPDF,
          dispatchDate,
          selectedDispatchCourier,
          selectedNumberOfPackages,
          remarks,
          docketNumber,
        } = this.formData
        this.updateLoading = true
        this.updateError = null

        const payload = new FormData()
        if (checkedPDF) {
          payload.append('checked_pdf_file', checkedPDF)
        }
        payload.append('status', status)
        payload.append('closed_on', closedOn)
        payload.append('dispatch_date', dispatchDate || '')
        payload.append('dispatch_courier', selectedDispatchCourier ? selectedDispatchCourier.id : '')
        payload.append('number_of_packages', selectedNumberOfPackages ? selectedNumberOfPackages.value : '')
        payload.append('remarks', remarks)
        payload.append('docket_number', docketNumber || '')

        const res = await axios.patch(`/returns/supplier_return/${this.itemId}/`, payload)
        this.itemDetails = res.data
        this.updateFormData()

        this.$emit('onUpdate')
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Data updated successfully!',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      } catch (error) {
        this.updateError = error?.response?.data?.non_field_errors?.[0] || 'Something Went wrong!'
      } finally {
        this.updateLoading = false
      }
    },
    async handleRematchItems() {
      const confirmed = await this.$bvModal.msgBoxConfirm(
        'This will remove all existing matches and re-match items from linked credit notes.',
        {
          title: 'Re-match Items?',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Yes, Re-match',
          cancelTitle: 'Cancel',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: true,
          centered: true,
        },
      )
      if (!confirmed) {
        return
      }

      this.rematchLoading = true
      this.rematchError = null
      try {
        const res = await axios.post(`/returns/supplier_return/${this.itemId}/rematch_items/`)
        this.itemDetails = res.data
        this.updateFormData()
        this.$emit('onUpdate')
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Items re-matched successfully!',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      } catch (error) {
        this.rematchError = (error && error.response && (error.response.data.detail || error.response.data.error))
          || 'Something went wrong while re-matching items'
      } finally {
        this.rematchLoading = false
      }
    },
    async handleActionTaken() {
      this.actionTakenLoading = true
      try {
        const res = await axios.post(`/returns/supplier_return/${this.itemId}/action_taken/`)
        this.itemDetails = res.data
        this.updateFormData()
        this.$emit('onUpdate')
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Action marked as taken!',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      } catch (error) {
        this.updateError = (error && error.response && (error.response.data.detail || error.response.data.error))
          || 'Something went wrong while clearing action required'
      } finally {
        this.actionTakenLoading = false
      }
    },
    addSupplierCreditNoteHandler() {
      this.showAddForm = true
      this.editSupplierCreditNoteId = null
    },
    editSupplierCreditNoteHandler(id) {
      this.editSupplierCreditNoteId = id
      this.showAddForm = false
    },
    closeFormsHandler() {
      this.showAddForm = false
      this.editSupplierCreditNoteId = null
    },
    handleItemsUpdated(updatedDetails) {
      this.itemDetails = updatedDetails
      this.updateFormData()
      this.$emit('onUpdate')
    },
    timelineIcon(eventType) {
      if (eventType === 'User Remark') {
        return 'MessageSquareIcon'
      }
      return 'MailIcon'
    },
    timelineVariant(eventType) {
      if (eventType === 'User Remark') {
        return 'primary'
      }
      if (eventType === 'Details Email Sent') {
        return 'info'
      }
      return 'success'
    },
    timelineTitle(entry) {
      if (entry.event_type === 'User Remark') {
        return 'User Remark'
      }
      return entry.event_type
    },
    timelineSubtitle(entry) {
      if (entry.event_type === 'User Remark') {
        return entry.remark
      }
      return entry.items_count != null ? `${entry.items_count} items` : 'Items'
    },
    timelineMeta(entry) {
      const parts = []
      if (entry.created_by_fullname) {
        parts.push(entry.created_by_fullname)
      }
      if (entry.created_at) {
        parts.push(this.formatedDate(entry.created_at, 'DD-MM-YYYY LT'))
      }
      return parts.join(' · ')
    },
    async handleAutoActionRequired(value) {
      this.autoActionLoading = true
      try {
        const res = await axios.post(
          `/returns/supplier_return/${this.itemId}/set_auto_action_required/`,
          { auto_action_required: value },
        )
        this.itemDetails = res.data
        this.updateFormData()
      } catch (error) {
        this.$set(this.itemDetails, 'auto_action_required', !value)
        this.updateError = (error && error.response && (error.response.data.detail || error.response.data.error))
          || 'Something went wrong while updating auto action required'
      } finally {
        this.autoActionLoading = false
      }
    },
    async handleAddRemark() {
      const remark = this.newRemark.trim()
      if (!remark) {
        return
      }
      this.remarkLoading = true
      this.remarkError = null
      try {
        await axios.post(`/returns/supplier_return/${this.itemId}/add_remark/`, {
          remark,
          follow_up_date: this.followUpDate || null,
        })
        this.newRemark = ''
        this.followUpDate = ''
        this.fetchDetails()
        this.$emit('onUpdate')
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Remark added!',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      } catch (error) {
        this.remarkError = (error && error.response && (error.response.data.detail || error.response.data.error))
          || 'Something went wrong while adding remark'
      } finally {
        this.remarkLoading = false
      }
    },
  },
}
</script>
